import React from 'react';
import { Box, OutlinedInput, Typography } from '@mui/material';

// Shared look for the login inputs (on the dark glass panel): label above, rounded field with a blue focus ring
export const authInputSx = {
  width: "100%",
  height: 46,
  borderRadius: "10px",
  backgroundColor: "rgba(255, 244, 232, 0.06)",
  fontSize: 15,
  color: "#FFF7ED",
  transition: "background-color 120ms ease, box-shadow 120ms ease",
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(255, 244, 232, 0.14)" },
  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(255, 244, 232, 0.28)" },
  "&.Mui-focused": { backgroundColor: "rgba(255, 244, 232, 0.09)", boxShadow: "0 0 0 3px rgba(77, 163, 255, 0.2)" },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#4DA3FF", borderWidth: 1 },
  "& input::placeholder": { color: "rgba(255, 244, 232, 0.4)", opacity: 1 },
  // Keep browser autofill from painting the field bright yellow / white
  "& input:-webkit-autofill": {
    WebkitBoxShadow: "0 0 0 100px #2B211F inset",
    WebkitTextFillColor: "#FFF7ED",
    caretColor: "#FFF7ED",
    borderRadius: "inherit",
  },
};

export const AuthFieldLabel = ({ htmlFor, children, action }) => (
  <Box sx={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", mb: 0.75 }}>
    <Typography component="label" htmlFor={htmlFor} sx={{ fontSize: 14, fontWeight: 500, color: "rgba(255, 244, 232, 0.85)" }}>
      {children}
    </Typography>
    {action}
  </Box>
);

const InputFieldWithLabel = ({
  id,
  label,
  type = "text",
  placeholder,
  autoComplete,
  autoFocus,
  onEnterKey,
  onValueChange,
}) => {
  return (
    <Box sx={{ width: "100%" }}>
      <AuthFieldLabel htmlFor={id}>{label}</AuthFieldLabel>
      <OutlinedInput
        id={id}
        name={id}
        type={type}
        placeholder={placeholder}
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        sx={authInputSx}
        onChange={(event) => {
          onValueChange(event.target.value);
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter' && onEnterKey) {
            onEnterKey();
          }
        }}
      />
    </Box>
  )
}

export default InputFieldWithLabel
